import React, { useState, Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormSection, TextField, SelectField, TextAreaField, DisplayField } from '../components/FormComponents';
import { mockProducts, masterDataSets } from '../data/mockData';
export function StockThresholdForm() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const mode = id ? 'edit' : 'create';
  const [formData, setFormData] = useState<any>({
    productId: '',
    warehouse: '',
    minStockLevel: '',
    reorderPoint: '',
    reorderQuantity: '',
    alertChannels: {
      email: false,
      inApp: false,
      sms: false
    },
    alertFrequency: '',
    description: '',
    status: 'Active'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleCheckboxChange = (channel: string) => {
    setFormData({
      ...formData,
      alertChannels: {
        ...formData.alertChannels,
        [channel]: !formData.alertChannels[channel]
      }
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Stock Threshold ${mode === 'create' ? 'created' : 'updated'} successfully!`);
    navigate('/stock-thresholds');
  };
  const productOptions = mockProducts.map(p => ({
    value: p.id,
    label: `${p.productName} (${p.productCode})`
  }));
  const warehouseOptions = (masterDataSets.warehouses || []).filter(wh => wh.status === 'Active').map(wh => ({
    value: wh.name,
    label: `${wh.name} (${wh.code})`
  }));
  return <div className="space-y-6 max-w-4xl mx-auto" data-id="element-2594">
      <div className="flex items-center justify-between" data-id="element-2595">
        <div data-id="element-2596">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-2597">
            {mode === 'create' ? 'Create Stock Threshold' : 'Edit Stock Threshold'}
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-2598">
            Configure stock levels and alert settings for a product.
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="bg-white shadow-sm rounded-lg border border-gray-200 p-6 md:p-8" data-id="element-2599">
        <FormSection title="Threshold Details" data-id="element-2600">
          <SelectField label="Product" name="productId" value={formData.productId} onChange={handleChange} required options={productOptions} data-id="element-2601" />
          <SelectField label="Warehouse" name="warehouse" value={formData.warehouse} onChange={handleChange} required options={warehouseOptions} data-id="element-2602" />
          <TextField label="Min Stock Level" name="minStockLevel" type="number" value={formData.minStockLevel} onChange={handleChange} required data-id="element-2603" />
          <TextField label="Reorder Point" name="reorderPoint" type="number" value={formData.reorderPoint} onChange={handleChange} required data-id="element-2604" />
          <TextField label="Reorder Quantity" name="reorderQuantity" type="number" value={formData.reorderQuantity} onChange={handleChange} required data-id="element-2605" />
        </FormSection>

        <FormSection title="Alerts & Notifications" data-id="element-2606">
          <div className="md:col-span-2" data-id="element-2607">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2608">
              Alert Channels <span className="text-red-500" data-id="element-2609">*</span>
            </label>
            <div className="flex space-x-6" data-id="element-2610">
              <label className="flex items-center" data-id="element-2611">
                <input type="checkbox" className="h-4 w-4 text-indigo-600 border-gray-300 rounded" checked={formData.alertChannels.email} onChange={() => handleCheckboxChange('email')} data-id="element-2612" />
                <span className="ml-2 text-sm text-gray-900" data-id="element-2613">Email</span>
              </label>
              <label className="flex items-center" data-id="element-2614">
                <input type="checkbox" className="h-4 w-4 text-indigo-600 border-gray-300 rounded" checked={formData.alertChannels.inApp} onChange={() => handleCheckboxChange('inApp')} data-id="element-2615" />
                <span className="ml-2 text-sm text-gray-900" data-id="element-2616">In App</span>
              </label>
              <label className="flex items-center" data-id="element-2617">
                <input type="checkbox" className="h-4 w-4 text-indigo-600 border-gray-300 rounded" checked={formData.alertChannels.sms} onChange={() => handleCheckboxChange('sms')} data-id="element-2618" />
                <span className="ml-2 text-sm text-gray-900" data-id="element-2619">SMS</span>
              </label>
            </div>
          </div>
          <SelectField label="Alert Frequency" name="alertFrequency" value={formData.alertFrequency} onChange={handleChange} required options={[{
          value: 'Immediate',
          label: 'Immediate'
        }, {
          value: 'Daily',
          label: 'Daily'
        }, {
          value: 'Weekly',
          label: 'Weekly'
        }]} data-id="element-2620" />
          <TextAreaField label="Description" name="description" value={formData.description} onChange={handleChange} rows={3} data-id="element-2621" />
        </FormSection>

        <div className="mt-8 pt-5 border-t border-gray-200 flex justify-end space-x-3" data-id="element-2622">
          <button type="button" onClick={() => navigate(-1)} className="px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-2623">
            Cancel
          </button>
          <button type="submit" className="px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-2624">
            {mode === 'create' ? 'Save Threshold' : 'Update Threshold'}
          </button>
        </div>
      </form>
    </div>;
}